<template>
  <div class="h-full">
    <div v-if="showForm" class="bg-white flex flex-col gap-6 w-full h-full">
      <div class="flex flex-col gap-3 h-full">edit or create</div>
    </div>
    <div v-else class="h-full">
      <OrganizationStructureLayout :sections="sections" />
    </div>
  </div>
</template>

<script>
import OrganizationStructureLayout from "@/pages/admin/organizations/tabs/OrganizationStructureLayout.vue";
import OrganizationItemCreateAndEdit from "@/pages/admin/organizations/tabs/create_and_edit/OrganizationItemCreateAndEdit.vue";

export default {
  name: "OrganizationStructure",
  components: {
    OrganizationItemCreateAndEdit,
    OrganizationStructureLayout,
  },
  computed: {
    uuid() {
      return this.$route.params.id;
    },
    showForm() {
      return (
        this.$route.name === "organization_new" ||
        this.$route.name === "organization_item"
      );
    },
    sections() {
      return [
        {
          title: "Структурные подразделения",
          items: [
            {
              label: "Добавленные структурные подразделения",
              values: [
                {
                  lang: "Наименование структурного подразделения (рус)",
                  text: "Комитет Регистрационной службы МЮ РК",
                },
                {
                  lang: "Наименование структурного подразделения (қаз)",
                  text: "ҚР Әділет министрлігінің Тіркеу қызметі комитеті",
                },
                { lang: "Роли структурного подразделения", text: "Не выбрано" },
              ],
            },
          ],
        },
      ];
    },
  },
};
</script>
